import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { CopyDepartmentRequest } from 'src/types/department';
import axiosInstance from 'src/utils/axios';

interface UseCopyDepartmentMutationOptions {
  companyId: number;
  sourceDepartmentId: number;
  onSuccess?: (data: AxiosResponse<any>) => void;
  onError?: (error: any) => void;
}

const useCopyDepartmentMutation = ({
  companyId,
  sourceDepartmentId,
  onSuccess,
  onError,
}: UseCopyDepartmentMutationOptions) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: CopyDepartmentRequest) => {
      const res = await axiosInstance.post(
        api.copyDepartment(companyId, sourceDepartmentId),
        params
      );
      return res;
    },
    onSuccess: (data) => {
      // Invalidate department list queries to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.department.departmentList(companyId.toString())],
      });
      // Invalidate clients query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: [...queryKeys.company.clients(companyId.toString())],
      });
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useCopyDepartmentMutation;
